import { useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import PageTitleWrapper from '../../../components/PageTitleWrapper'
import PageContainerWrapper from '../../../components/PageContainerWrapper'
import { Alert, Grid, Typography } from '@mui/material'
import Footer from '../../../components/Footer'
import { useAppDispatch, useAppSelector } from '../../../hooks'
import { fetchPendingBillsAction } from '../../../store/pendingBills'
// import { createPendingBills } from '../../../services'
import ListTable from './ListTable'

function PendingBills() {
  const { data } = useAppSelector((state) => state.pendingBills)
  const dispatchAction = useAppDispatch()

  useEffect(() => {
    //createPendingBills().then((a)=>{console.log(a)}).catch((e)=>console.log(e))
    dispatchAction(fetchPendingBillsAction(false))
  }, [])

  return (
    <>
      <Helmet>
        <title>Manage Pending Bills</title>
      </Helmet>
      <PageTitleWrapper>
        <Grid container alignItems="flex-end">
          <Grid item xs>
            <Typography variant="h3" component="h3">
              Software usage bills
            </Typography>
          </Grid>
        </Grid>
      </PageTitleWrapper>
      <PageContainerWrapper>
        <Alert
          severity="info"
          variant="outlined"
          sx={{
            mb: 2,
            py: 1.5,
            px: 2,
            fontSize: '0.9375rem',
            lineHeight: 1.55,
            fontWeight: 400,
            color: 'text.primary',
            backgroundColor: 'rgba(25, 118, 210, 0.06)',
            borderColor: 'divider',
            '& .MuiAlert-icon': {
              color: 'info.main',
            },
            '& .MuiAlert-message': {
              width: '100%',
            },
          }}
        >
          <Typography variant="body2" component="span" sx={{ display: 'block' }}>
            Going forward, all invoices will be issued by{' '}
            <strong>TEJSE ONLINE SERVICES PRIVATE LIMITED</strong>. Applicable
            invoices will include <strong>18% GST</strong> as per current tax
            rules.
          </Typography>
        </Alert>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>
            <ListTable pendingBills={data} />
          </Grid>
        </Grid>
      </PageContainerWrapper>
      <Footer />
    </>
  )
}

export default PendingBills
